const codeBlockToken = { block: "code_block", noCloseToken: true };

export default codeBlockToken;
